// src/api/generateQsn.js
import { getRequest, postRequest } from "./api";

// Get standards + classes
export const getStandardsAndClasses = async () => {
  return getRequest("/questionpaper/std_class/");
};

// Get subjects by class id
export const getSubjectsByClass = async (classId) => {
  return getRequest(`/questionpaper/subject/?std_class_id=${classId}`);
};

// Get PDFs by subject id
export const getPdfsBySubject = async (subjectId) => {
  return getRequest(
    `/questionpaper/question-papers-upload/?std_subject_id=${subjectId}`
  );
};

// Generate PDF with school header
export const generatePdfWithHeader = async (data) => {
  return postRequest("/questionpaper/generate-pdf-with-header/", data);
};
